// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, verifyForgotPassword } from "../../Utils/Constants";
import { toast } from "react-toastify";

export const hitVerifyForgotPasswordCodeApi = createAsyncThunk(
  "hitVerifyForgotPasswordCodeApi",
  async (payload) => {
    try {   
      const url = ApiBaseUrl + verifyForgotPassword;
      const response = await axios.put(url, payload);
      return response.data;
    } catch (error) {
     // toast.error(error.response.data.message);
      throw error.response.data;
    }
  }
);

const VerifyForgotPasswordSlice = createSlice({
  name: "verifyForgotPasswordReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearVerifyForgotPasswordData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitVerifyForgotPasswordCodeApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitVerifyForgotPasswordCodeApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitVerifyForgotPasswordCodeApi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearVerifyForgotPasswordData } = VerifyForgotPasswordSlice.actions;
export default VerifyForgotPasswordSlice.reducer;